const { upgradeArray } = require('../utils')

const DICTIONARIES = upgradeArray([ 'phone:mnp', 'phone:ranges', 'phone:opgroups' ])
const DICTIONARIES_STATUSES = upgradeArray([
  'created',
  'downloading', // Убрать после перехода на import
  'importing',
  'importError',
  'ready',
  'compiling',
  'compiled',
  'compileError',
  'activated'
])
const DICTIONARIES_TYPES = upgradeArray([ 'def', 'abc' ])

module.exports = {
  DICTIONARIES,
  DICTIONARIES_STATUSES,
  DICTIONARIES_TYPES
}
